/**
 * QA environment configuration.
 * Host derived from HRMSApi/appsettings.boltqa.json ("Jwt:Issuer": "https://qaapi.vibgyor.co.in/").
 */
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  apiBaseUrl: 'https://qaapi.vibgyor.co.in/api/platform-admin',
  boltUiBaseUrl: 'https://qabolt.vibgyor.co.in',
  appName: 'BoltConsole',
};
